import { Helmet } from "react-helmet";
import { GlobalStyle } from "./globalStyles";
import { GlobalVariables } from "./globalVariables";

export const FontLinks = () => (
	<>
		<link
			href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300..700&display=swap"
			rel="stylesheet"
		/>
		<link
			href="https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap"
			rel="stylesheet"
		/>
		<link
			href="https://fonts.googleapis.com/css2?family=Space+Mono:ital,wght@0,400;0,700;1,400;1,700&display=swap"
			rel="stylesheet"
		/>
		<link
			href="https://fonts.googleapis.com/css2?family=Zalando+Sans+Expanded:wght@300..700&display=swap"
			rel="stylesheet"
		/>
		<link
			href="https://fonts.googleapis.com/css2?family=Zalando+Sans+SemiExpanded:wght@300..700&display=swap"
			rel="stylesheet"
		/>
	</>
);

export const StyleProvider = ({ children }: { children: React.ReactNode }) => {
	return (
		<>
			<FontLinks />
			<GlobalStyle />
			<GlobalVariables />
			{children}
		</>
	);
};
